import React from 'react';

export type NavigatePreviewContextValue = {
    previewMode: string | null;
    setPreviewOverrideSlug: (slug: string | null) => void;
    setPreviewMode: (mode: string) => void;
};

const NavigatePreviewContext = React.createContext<NavigatePreviewContextValue | null>(null);

export default NavigatePreviewContext;
